import { render } from "./Corporates.vue?vue&type=template&id=01c77ef2&scoped=true"
import script from "./Corporates.vue?vue&type=script&lang=js"
export * from "./Corporates.vue?vue&type=script&lang=js"

import "./Corporates.vue?vue&type=style&index=0&id=01c77ef2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c77ef2"]])

export default __exports__